// extracted by mini-css-extract-plugin
module.exports = {"adBanner":"styles_adBanner__CkICr"};
module.exports.__checksum = "021ddb48c115"